import { HandicapIndex } from './HandicapIndex';

export default HandicapIndex;
